export default (state, action) => {
    switch(action.type) {
        case 'GET_MENUS':
            return {
                ...state,
                menus: action.payload,
                loading: false
            };
        case 'ADD_MENU':
            return {
                ...state,
                menus: [action.payload, ...state.menus],
                loading: false
            };
        case 'UPDATE_MENU':
            return {
                ...state,
                menus: state.menus.map(menu => menu.menu_id === action.payload.menu_id ? action.payload : menu),
                loading: false
            };
        case 'DELETE_MENU':
            return {
                ...state,
                menus: state.menus.filter(menu => menu.menu_id !== action.payload),
                loading: false
            };
        case 'SET_CURRENT_MENU':
            return {
                ...state,
                current: action.payload
            };
        case 'CLEAR_CURRENT_MENU':
            return {
                ...state,
                current: null
            };
        case 'MENU_ERROR':
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
}
